import createReactComponent from '../createReactComponent';
export default createReactComponent('math-pi', 'IconMathPi', [
  ['path', { d: 'M7 20v-16', key: 'svg-0' }],
  ['path', { d: 'M17 4v16', key: 'svg-1' }],
  ['path', { d: 'M20 4h-16', key: 'svg-2' }],
]);
